export const LANGUAGES = {
  pt: "Português",
  en: "English",
};

export const TRANSLATIONS = {
  pt: {
    subtitle:"Celebridade do dia",
    guessinputplaceholder: "Insira o nome da Celebridade...",
    guess: "Adivinhar",
    hint: "Dica",
    hints: "Dicas",
    quit: "Desistir",
    settings: "Definições",
    gameMode: "Modo de jogo",
    classic: "Clássico",
    musicians: "Apenas Músicos",
    lose_banner_before:"😢 A Celebridade era ",
    lose_banner_after:". Melhor sorte para a próxima!",
    win_banner_before:"🎉 Descobriste ",
    win_banner_after:"!",
    table: {
      picture: "Foto",
      name: "Nome",
      gender: "Género",
      children: "#Filhos",
      height: "Altura",
      job: "Profissão",
      year: "Ano",
      place: "Local",
      status: "Estado",
      fame: "Fama",
      generations: "Gerações",
      zodiac: "Zodíaco",
      modespecific1_music: "Estilo Musical",
      modespecific1_politics: "Partido Político",
      modespecific1_comedian: "Tipo de performance",
      modespecific2_comedian: "Meio de apresentação",
    },
    tooltips: {
      modespecific1_music_tooltip: "Estilo ou género musical principal",
      modespecific1_politics_tooltip: "Afiliação partidária",
      modespecific1_comedian_tooltip: "Stand-up / Sketch / Improv / Musical",
      modespecific2_comedian_tooltip: "Ao Vivo / TV / Rádio / Redes Sociais",
      job_tooltip: "Principal ocupação pública da personagem",
      fame_tooltip: "Nível de reconhecimento público: 1=alto, 2=médio, 3=baixo",
      generations_tooltip: "Gerações que conhecem melhor a personagem",
    },
    height_labels: {
      tall: "alto",
      average: "médio",
      short: "baixo",
    },
    job: {
      // Arts & Media
      academic: "Académico",
      visual_artist: "Artista Plástico",
      actor: "Ator",
      screenwriter: "Guionista",
      comedian: "Humorista",
      musician: "Músico",
      model: "Modelo",
      youtuber: "Youtuber",
      host: "Apresentador",
      journalist: "Jornalista",
      writer: "Escritor",

      // Sports
      athlete: "Atleta",
      coach: "Treinador",
      sports_manager: "Dirigente Desportivo",

      // STEM / Professions
      engineer: "Engenheiro",
      doctor: "Médico",
      architect: "Arquiteto",
      chef: "Chef",
      pilot: "Aviador",

      // Politics / Power
      politician: "Político",
      royalty: "Rei",
      military: "Militar",
      religious: "Religioso",

      // Business / Society
      businessperson: "Empresário",
      socialite: "Socialite",

      // Other
      activist: "Ativista",
      explorer: "Explorador",
      criminal: "Criminoso",
      victim: "Vítima",
    },
    status: {
      alive: "Vivo",
      dead: "Morto",
    },
    zodiac: {
      aries: "Carneiro",
      taurus: "Touro",
      gemini: "Gémeos",
      cancer: "Caranguejo",
      leo: "Leão",
      virgo: "Virgem",
      libra: "Balança",
      scorpio: "Escorpião",
      sagittarius: "Sagitário",
      capricorn: "Capricórnio",
      aquarius: "Aquário",
      pisces: "Peixes",
    },
    reporterror: "Reportar erro na base de dados",
  },

  en: {
    subtitle:"Daily celebrity",
    guessinputplaceholder: "Enter celebrity name...",
    guess: "Guess",
    hint: "Hint",
    hints: "Hints",
    quit: "Quit",
    settings: "Settings",
    gameMode: "Game mode",
    classic: "Classic",
    musicians: "Musicians only",
    lose_banner_before:"😢 The character was ",
    lose_banner_after:". Better luck next time!",
    win_banner_before:"🎉 You found ",
    win_banner_after:"!",
    table: {
      picture: "Picture",
      name: "Name",
      gender: "Gender",
      children: "#Children",
      height: "Height",
      job: "Job",
      year: "Year",
      place: "Place",
      status: "Status",
      fame: "Fame",
      generations: "Generations",
      zodiac: "Zodiac",
      modespecific1_music: "Music Style",
      modespecific1_politics: "Political Party",
      modespecific1_comedian: "Performance Format",
      modespecific2_comedian: "Presentation Channel",
    },
    tooltips: {
      modespecific1_music_tooltip: "Main music genre or style",
      modespecific1_politics_tooltip: "Political party affiliation",
      modespecific1_comedian_tooltip: "Stand-up / Sketch / Improv / Musical",
      modespecific2_comedian_tooltip: "Live / TV / Radio / Social Networks",
      job_tooltip: "Main professional occupation of the celebrity",
      fame_tooltip: "Public recognition level: 1=high, 2=medium, 3=low",
      generations_tooltip: "Generations that know the celebrity better",
    },
    height_labels: {
      tall: "tall",
      average: "average",
      short: "short",
    },
    job: {
      // Arts & Media
      academic: "Academic",
      visual_artist: "Visual Artist",
      actor: "Actor",
      screenwriter: "Screenwriter",
      comedian: "Comedian",
      musician: "Musician",
      model: "Model",
      youtuber: "Youtuber",
      host: "Host",
      journalist: "Journalist",
      writer: "Writer",

      // Sports
      athlete: "Athlete",
      coach: "Coach",
      sports_manager: "Sports Manager",

      // STEM / Professions
      engineer: "Engineer",
      doctor: "Doctor",
      architect: "Architect",
      chef: "Chef",
      pilot: "Pilot",

      // Politics / Power
      politician: "Politician",
      royalty: "Royalty",
      military: "Military",
      religious: "Religious",

      // Business / Society
      businessperson: "Businessperson",
      socialite: "Socialite",

      // Other
      activist: "Sctivist",
      explorer: "Explorer",
      criminal: "Criminal",
      victim: "Victim",
    },
    status: {
      alive: "Alive",
      dead: "Dead",
    },
    zodiac: {
      aries: "Aries",
      taurus: "Taurus",
      gemini: "Gemini",
      cancer: "Cancer",
      leo: "Leo",
      virgo: "Virgo",
      libra: "Libra",
      scorpio: "Scorpio",
      sagittarius: "Sagittarius",
      capricorn: "Capricorn",
      aquarius: "Aquarius",
      pisces: "Pisces",
    },
    reporterror: "Report database error",
  },
};